export default "__VITE_ASSET__BYEZOvNH__";